import ReportPreviewTable from './report-preview-table';
export default function() {
  var self = this;
  self.salesforce_report_id = ko.observable();
  self.salesforce_reports = ko.observableArray();
  self.user_field_mappings = ko.mapping.fromJS([
    {
      user_attribute: 'first_name',
      label: 'First Name',
      salesforce_field_name: null,
      required: true
    },
    {
      user_attribute: 'last_name',
      label: 'Last Name',
      salesforce_field_name: null,
      required: true
    },
    {
      user_attribute: 'email',
      label: 'Email',
      salesforce_field_name: null,
      required: true
    },
    {
      user_attribute: 'telephone_number',
      label: 'Telephone Number',
      salesforce_field_name: null,
      required: false
    },
    {
      user_attribute: 'external_id',
      label: 'External ID',
      salesforce_field_name: null,
      required: true
    }
  ]);
  self.salesforce_report = ko.observable();
  self.salesforce_table_fields = ko.observableArray();
  self.table = ko.observable();
  this.paginationOptions = ['10', '25', '50', '100'];
  this.selectedPer = ko.observable(this.paginationOptions[0]);
  this.selectedPage = ko.observable(1);
  self.mapped_salesforce_reports = {};
  self.$el = document.getElementById('js-admin-salesforce-settings');
  self.$selectedCourses = $('#selected-courses');

  self.initData = function() {
    const json = $('#js-admin-salesforce-settings-json').val();
    const data = JSON.parse(json);
    self.salesforce_reports(data.salesforce_reports);
    self.courseListing = data.courses;
    // console.log(data);

    self.salesforce_report_id.subscribe(function (newValue) {
      if (newValue) {
        self.fetchUserFieldMappings();
      }
    });
  };

  self.fetchUserFieldMappings = function() {
    const reportId = self.salesforce_report_id();
    const url = Kadenze.Routes.user_field_mappings_admin_salesforce_index_path({report_id: reportId});

    const request = new Kadenze.AjaxRequest({
      type: 'get',
      dataAsJSON: false,
      url: url,
      data: {},
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(fieldData) {
      // console.log(fieldData);
      self.salesforce_table_fields(fieldData.salesforce_table_fields);
      self.salesforce_report(fieldData.salesforce_report);

      let idField = _.find(fieldData.salesforce_table_fields, function(salesforceField){
        return salesforceField.name.indexOf('ID') !== -1;
      });

        // Automatically set the field mapping if a Salesforce field has the same exact name
      ko.utils.arrayForEach(self.user_field_mappings(), function(field){
        if (!field.salesforce_field_name()) {
          var salesforceFieldWithSameName = _.findWhere(fieldData.salesforce_table_fields, {label: field.label()});
          if (salesforceFieldWithSameName) {
            field.salesforce_field_name(salesforceFieldWithSameName.name);
          } else if ((field.user_attribute() === 'external_id') && idField) {
            field.salesforce_field_name(idField.name);
          }
        }
      });

      ko.utils.arrayForEach(self.user_field_mappings(), function(field){
        field.salesforce_field_name.subscribe(self.updateMappedReport);
      });

      self.updateMappedReport();

      $('.bootstrap-select .bootstrap-select').siblings('button').remove();
    });

    request.fail(function(data) {
      Kadenze.UIUtil.showNotice(self.$el, data, 3000);
    });
  };

  self.fieldsAreValid = function() {
    let isValid = true;
    _.each(self.user_field_mappings(), function(field){
      if (field.required() && !field.salesforce_field_name()) {
        isValid = false;
      }
    });
    return isValid;
  };

  self.valueForCell = function(dataCells, index) {
    const fieldMapping = self.user_field_mappings()[index];
    const fieldIndex = _.findIndex(self.salesforce_table_fields(), {name: fieldMapping.salesforce_field_name()});
    const attr = dataCells[fieldIndex];
    if (attr) {
      return attr.label;
    } else {
      return '';
    }
  };

  self.importReport = function() {
    const url = Kadenze.Routes.trigger_import_admin_salesforce_index_path();
    const courseIds = _.pluck(self.$selectedCourses.tagsinput('items'), 'id');

    const request = new Kadenze.AjaxRequest({
      type: 'post',
      dataAsJSON: true,
      url: url,
      data: {
        report_id: self.salesforce_report_id(),
        user_field_mappings: ko.mapping.toJS(self.user_field_mappings()),
        course_ids: courseIds
      },
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function() {
      Kadenze.Notice.success({title: 'Successfully triggered an import of students from Salesforce.'});
      let redirect = Kadenze.Routes.admin_external_applications_path();
      Kadenze.Request.pjax({ url: redirect });
    });

    request.fail(function(data) {
      Kadenze.UIUtil.showNotice(self.$el, data, 3000);
    });
  };

  self.selected_courses = function(key){
    return $.map(self.$selectedCourses.tagsinput('items'), function (item) { return key ? item[key] : item; });
  };

  self.courseSource = function(query, cb) {
    const filteredList = $.grep(self.courseListing, function (item) {
      return item.name.match(query);
    });

    const mapped = $.map(filteredList, function (item) { return item; });
    cb(mapped);
  };

  self.initTypeahead = function() {
    self.$selectedCourses.tagsinput({
      confirmKeys: [9, 13, 188],
      itemValue: 'id',
      itemText: 'name'
    });

    $('.bootstrap-tagsinput input', self.$selectedCourses.parent()).typeahead({
      minLength: 0,
      hint: false,
      highlight: false
    }, {
      name: 'noname',
      displayKey: 'name',
      source: self.courseSource
    }).bind('typeahead:selected', $.proxy(function (obj, datum) {
      self.$selectedCourses.tagsinput('add', datum);
      this.value = '';
    }));

    $('.bootstrap-tagsinput input', self.$selectedCourses.parent()).bind('typeahead:opened', function () {
      let ev = $.Event('keydown');
      ev.keyCode = ev.which = 40;
      $(this).trigger(ev);
      $(this).typeahead('val', '');
      return true;
    });
  };

  self.updateMappedReport = function () {
    const reportData = self.salesforce_report();
    let fieldIndexes = {};
    ko.utils.arrayForEach(self.user_field_mappings(), function(field){
      const fieldIndex = _.findIndex(self.salesforce_table_fields(), {name: field.salesforce_field_name()});
      fieldIndexes[field.label()] = fieldIndex;
    });
    // console.log(fieldIndexes);
    let mappedRows = [];
    if (reportData) {
      _.each(reportData.factMap['T!T'].rows, function(row) {
        let mappedRow = {};
        _.each(fieldIndexes, function(index, label) {
          const cell = row.dataCells[index];
          if (cell) {
            mappedRow[label] = cell.label;
          } else {
            mappedRow[label] = null;
          }
        });
        mappedRows.push(mappedRow);
      });
      // console.log(mappedRows);
      self.initDataTable(mappedRows);
    }
  };

  self.initDataTable = function (mappedRows) {
    const previewContainer = document.getElementById('js-preview-table-container');
    if (self.reportPreviewTable) {
      self.reportPreviewTable.updateData(mappedRows);
    } else {
      self.reportPreviewTable = new ReportPreviewTable(mappedRows, self.user_field_mappings());
      ko.applyBindingsWithValidation(self.reportPreviewTable, previewContainer, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
    }
  };

  const __construct = function() {
    console.log('constructor called for Admin.Salesforce.SettingsVM');
    self.initData();
    self.initTypeahead();
  }(this);
}

